var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('form',[_c('Marca'),_c('Modelo'),_c('div',{staticClass:"form-row"},[_c('Ano'),_c('Estado')],1),_c('BtnCotacao')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }